import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { authorizeClient } from '../../networking/client';
import { RootState } from '../store';

export interface OtherServices {
  service_id: string;
  remarks: string;
  work_order_other_services_log_id: string;
  service_type_id: string;
  service_name: string;
}

export interface OtherServicesState {
  status: string;
  allOtherServices: OtherServices[];
  otherServices: OtherServices[];
}

const initialState: OtherServicesState = {
  status: 'idle',
  allOtherServices: [],
  otherServices: [],
};

export const getOtherServices = createAsyncThunk(
  'get-healthpoint/otherServices',
  async (workOrderId: number, { dispatch, rejectWithValue }) => {
    try {
      const response = await authorizeClient.get(`/healthpoint/medical-service/${workOrderId}`);
      return response;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? {});
    }
  }
);

export const getAllOtherServices = createAsyncThunk(
  'get-healthpoint/AllOtherServices',
  async (locationId: number, { dispatch, rejectWithValue }) => {
    try {
      const response = await authorizeClient.get(
        `/healthpoint/medical-services?locationId=${locationId}`
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? {});
    }
  }
);

export const deleteOtherService = createAsyncThunk(
  'get-healthpoint/deleteOtherService',
  async (
    { logId, workOrderId }: { logId: string | undefined; workOrderId: number | undefined },
    { dispatch, rejectWithValue }
  ) => {
    if (!logId || !workOrderId) {
      return rejectWithValue('No valid service log ID provided');
    }
    try {
      const response = await authorizeClient.delete(`/healthpoint/medical-service/${logId}`);
      dispatch(getOtherServices(workOrderId));
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  }
);

export const otherServicesSlice = createSlice({
  name: 'otherServices',
  initialState,
  reducers: {
    resetOtherServices: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllOtherServices.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(getAllOtherServices.fulfilled, (state, action) => {
        state.status = 'idle';
        state.allOtherServices = action.payload?.data?.medicalServices;
      })
      .addCase(getOtherServices.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(getOtherServices.fulfilled, (state, action) => {
        state.status = 'idle';
        state.otherServices = action.payload?.data?.medicalServices;
      });
  },
});

export const { resetOtherServices } = otherServicesSlice.actions;

export default otherServicesSlice.reducer;

export const selectOtherServices = (state: RootState) => state.otherServices.otherServices;
export const selectAllOtherServices = (state: RootState) => state.otherServices.allOtherServices;
export const selectOtherServicesStatus = (state: RootState) => state.otherServices.status;
